import { render, staticRenderFns } from "./supplierOutsourceDetails.vue?vue&type=template&id=05df72c4"
import script from "./supplierOutsourceDetails.vue?vue&type=script&lang=js"
export * from "./supplierOutsourceDetails.vue?vue&type=script&lang=js"
import style0 from "./supplierOutsourceDetails.vue?vue&type=style&index=0&id=05df72c4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports